import React, { FC } from 'react';
import { Icons, IconType } from '../../atoms/Icon';
import { ScoreProps } from '../../atoms/Score';
import * as SC from './styled';
export type RecipeHeroDetailsProps = {
  className?: string;
  isPositive?: boolean;
  score?: ScoreProps;
  entries?: {
    icon: IconType;
    label: string;
    value: string;
  }[];
  date?: {
    text: string;
    time: string;
  };
};
const RecipeHeroDetails: FC<RecipeHeroDetailsProps> = ({
  className,
  isPositive,
  score,
  entries,
  date
}) => {
  return <SC.Container className={className}>
      <SC.Pictos>
        {isPositive && <SC.Positive icon={Icons.positiveFood} />}
        <SC.Grid>
          {score && <li>
              <SC.Score value={score.value} isV2={score.isV2} />
            </li>}
          {entries?.map((entry, i) => <SC.IconItem key={i}>
              <SC.Icon icon={entry.icon} />
              <SC.IconItemContent>
                <SC.IconItemLabel>{entry.label}</SC.IconItemLabel>
                <SC.IconItemValue>{entry.value}</SC.IconItemValue>
              </SC.IconItemContent>
            </SC.IconItem>)}
        </SC.Grid>
      </SC.Pictos>
      {date && <SC.Date dateTime={date.time}>{date.text}</SC.Date>}
    </SC.Container>;
};
export default RecipeHeroDetails;